import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { getSiteSettings } from "@/lib/api";

const WhatsAppFAB = () => {
  const [number, setNumber] = useState("");

  useEffect(() => {
    getSiteSettings()
      .then((settings) => setNumber((settings.whatsapp_number || "").trim()))
      .catch(() => setNumber(""));
  }, []);

  if (!number) return null;

  const cleanNumber = number.replace(/[^0-9+]/g, "");
  const href = `https://wa.me/${cleanNumber}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:bg-[#1ebe5d] hover:scale-110 transition-all duration-300"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};

export default WhatsAppFAB;
